import React from 'react';

interface Props {
  className?: string;
}

const HouseChimney: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Home">
      <path
        d="M18.3333 11.4258H16.4757L16.5046 18H15.3241H14.8611H11.8518V13.3125H8.14814V18H5.13888H4.67592H3.5214V16.9102C3.51851 16.8838 3.51851 16.8574 3.51851 16.8281V13.5469C3.51851 13.5205 3.51851 13.4912 3.5214 13.4648V11.4258H1.66666V10.0312L10.0116 3L13.7037 6.12012V3.9375H16.4815V8.4668L18.3333 10.0312V11.4258Z"
        fill="currentColor"
        id="Vector"
      />
    </g>
  </svg>
);

export default HouseChimney;
